export function editorEntity(e) {
  if (e.type !== 'LWPOLYLINE' || !Object.hasOwn(e, 'bulges')) return e
  const { bulges, ...rest } = e
  return { ...rest, bulge: e.bulge ?? bulges }
}

export function scaleEntityCoords(e, ws) {
  e = editorEntity(e)
  if (e.type === 'LINE' && e.start && e.end) {
    return { ...e, start: [e.start[0] * ws, e.start[1] * ws], end: [e.end[0] * ws, e.end[1] * ws] }
  }
  if (e.type === 'CIRCLE' && e.center) {
    return { ...e, center: [e.center[0] * ws, e.center[1] * ws], radius: e.radius * ws }
  }
  if (e.type === 'LWPOLYLINE' && e.points) {
    return {
      ...e,
      points: e.points.map(([x, y]) => [x * ws, y * ws]),
      holes: e.holes?.map(h => h.map(([x, y]) => [x * ws, y * ws])),
    }
  }
  return e
}

export function prepareUploadDataUnits(uploadData, units, sessionId = uploadData.session_id) {
  const appliedScale = units?.factor && units.factor !== 1 ? units.factor : 1
  const scale = manifest => manifest?.map(e => scaleEntityCoords(e, appliedScale))
  return {
    data: {
      ...uploadData,
      session_id: sessionId,
      original_manifest: scale(uploadData.original_manifest),
      cleaned_manifest: scale(uploadData.cleaned_manifest),
    },
    appliedScale,
    scaleFactor: appliedScale === 1 ? null : 1,
  }
}

// Drawing units dialog (AutoCAD UNITS): cm per drawing unit for each choice.
export const UNIT_OPTIONS = [
  { label: 'Millimeters', cm: 0.1 },
  { label: 'Centimeters', cm: 1 },
  { label: 'Meters', cm: 100 },
  { label: 'Inches', cm: 2.54 },
  { label: 'Feet', cm: 30.48 },
]
// A length typed in one of the unit choices, in centimetres.
export const cmFromUnit = (value, label) => value * UNIT_OPTIONS.find(o => o.label === label).cm

export const PLAUSIBLE_M = [7, 150]  // real floor plates; Modal's training footprints span 7.3-347 m

export const sameScale = (a, b) => Math.abs(a - b) / b < 1e-6

// {w, h} in metres from computeBounds() over a cm-scaled manifest; null when empty.
export function planSizeM(bounds) {
  if (!bounds || !Number.isFinite(bounds.minX)) return null
  return { w: (bounds.maxX - bounds.minX) / 100, h: (bounds.maxY - bounds.minY) / 100 }
}
